<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">حواله بین انبار</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center" style="gap: 12px;">  
                            <div class="col-3">
                                <label class="mb-0" style="white-space: nowrap;">از</label>  
                                <select 
                                    class="form-control" 
                                    v-model="fromStore" 
                                    @change="clearVarieties" 
                                    >
                                    <option v-for="agency in stores" :value="{id: agency.id,name: agency.label}">{{ agency.label }}</option>  
                                </select>  
                            </div>
                            <div class="col-3">
                                <label class="mb-0" style="white-space: nowrap;">به</label>  
                                <select 
                                    class="form-control" 
                                    v-model="toStore" 
                                    @change="clearVarieties" 
                                    >
                                    <option v-for="agency in stores" :value="{id: agency.id,name: agency.label}">{{ agency.label }}</option>  
                                </select>  
                            </div>
                            <div class="col-3">
                                <label for="" class="mb-0" style="width: 28%;">انتخاب فروشنده</label>
                                <multiselect placeholder="انتخاب کنید" v-model="seller" open-direction="bottom"
                                    :options="sellers" label="full_name" track-by="value" :searchable="true" :close-on-select="true"
                                    :show-labels="true" :disabled="disabled">
                                    <template slot="noOptions">
                                        موردی یافت نشد
                                    </template>
                                    <template slot="noResult">
                                        موردی یافت نشد
                                    </template>
                                </multiselect>
                            </div>
                            <button class="btn btn-success"   
                                    :disabled="!toStore"   
                                    data-toggle="modal"   
                                    data-target="#add-variety-modal">  
                                <i class="fa fa-plus"></i>  
                            </button>  
                        </div>  
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-responsive-sm table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>محصول</th>
                                <th>تنوع</th>
                                <th>تعداد({{ fromStore ? fromStore.name : '' }})</th>
                                <th>تعداد انتقالی</th>
                                <th>حذف</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(variety,index) in varieties" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ variety.product_title ? variety.product_title : variety.product.title }}</td>
                                <td>{{ variety.title ? variety.title : variety.variety_name }}</td>
                                <td>
                                {{ variety.store_items ? (variety.store_items.find(item => item.store_id == fromStore.id) ? 
                                    variety.store_items.find(item => item.store_id == fromStore.id).balance
                                : 0) :  balanceProductSku[fromStore.id] ? 
                                    balanceProductSku[fromStore.id]
                                : 0}}  
                                </td>
                                <td class="d-flex justify-content-center">
                                    <b-form-input type="number" v-model="variety.agencyQuantity" style="max-width: 80%;"/>
                                </td>
                                <td>
                                    <button  
                                        class="btn btn-sm btn-icon btn-danger text-white"  
                                        data-toggle="tooltip"  
                                        data-original-title="حذف"  
                                        style="margin-inline: 1px"  
                                        @click="deleteVariety(index)">  
                                        <i class="fa fa-trash-o"></i>  
                                    </button>  
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
                <!-- <Loading v-if="$root.isEmptyObject(items)" /> -->
            </div>
            <div class="card-footer" v-if="varieties.length > 0">
                <div class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-success text-right item-right" :disabled="isButtonDisabled" @click="submitData">ارسال</button>
                    <button   
                        :class="['btn', 'btn-warning', 'text-right', 'item-right',{ 'btn-disabled': !isButtonDisabled }]"  
                        :disabled="isButtonDisabled == false"  
                        @click="barcodeVarieties"   
                        style="margin-inline: 5px;">  
                        چاپ بارکد  
                    </button>
                    <button   
                        :class="['btn', 'btn-secondary', 'text-right', 'item-right',{ 'btn-disabled': !isButtonDisabled }]"  
                        :disabled="isButtonDisabled == false"  
                        @click="printVarieties"   
                        style="margin-inline: 5px;">  
                        پرینت  
                    </button>
                </div>
            </div>  
        </div>
        <div class="modal fade" id="add-variety-modal" style="display: none;" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <p class="modal-title font-weight-bold"></p>
                        <button aria-label="Close" class="close" data-dismiss="modal"><span
                                aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <ProductSearch
                            class="row"
                            :store="fromStore"
                            @selectProduct="selectTheProduct"
                            @selectVariety="selectedVariety"
                        />
                        <b-form-group label="انتخاب محصول">
                            <div class="row col-md-6" style="gap: 0.5rem">
                            <b-form-input
                                autocomplete="off"
                                ref="productSku"
                                v-model="productSku"
                                :disabled="disabled"
                                @keypress.prevent.enter="requestProduct"
                                type="text"
                            />
                            </div>
                        </b-form-group>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button class="btn btn-outline-warning text-right item-right" data-dismiss="modal">بستن</button>  
                        <button class="btn btn-success text-right item-right" @click="addVariety">ثبت</button>  
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import HavaleCreateLpml from '@@/core/pages/Havale/HavaleCreateLpml'
    export default {
        extends: HavaleCreateLpml
    }
</script>
<style scoped src="@@/core/pages/Havale/HavaleStyle.css"></style>